import React, { FC } from 'react';
import { useSnapshot } from 'valtio';
import AppSpinner from '../../common/components/AppSpinner';
import RepoSelectionStore from '../stores/onboarding-repo-selection-store';
import OnboardingAppSelection from '../components/app-selection-components/OnboardingAppSelection';
import {
  handleChooseAll,
  onContinueClick,
  searchRepos,
} from '../actions/onboarding-repo-selection-actions';
import { setMonitorAllNewlyCreatedResources } from '../store-actions/repo-selection-store-actions';
import { useScan } from '../../new-scan/actions/scan-actions';

const onChooseAll = (e: React.ChangeEvent<HTMLInputElement>) => {
  handleChooseAll(e.target.checked);
};

const handleSearchRepos = (e: React.ChangeEvent<HTMLInputElement>) => {
  searchRepos(e.target.value);
};

const handleMonitorNewlyCreatedRepos = (
  e: React.ChangeEvent<HTMLInputElement>,
) => {
  setMonitorAllNewlyCreatedResources(e.target.checked);
};

const OnboardingAppSelectionContainer: FC<
  React.PropsWithChildren<unknown>
> = () => {
  const {
    filteredRepoTreeData,
    searchValue,
    isChooseAllSelected,

    isLoading,
    monitorAllNewlyCreatedResources,
    checkedReposUtils,
  } = useSnapshot(RepoSelectionStore);
  const { maxReposToScan } = useScan();
  const { isContinueDisabled, checkedReposNumber, reposFound } =
    checkedReposUtils;
  return (
    <>
      {(!filteredRepoTreeData || !maxReposToScan) && (
        <AppSpinner disablePositionAbsolute text='Fetching your repos' />
      )}
      {filteredRepoTreeData && maxReposToScan && (
        <OnboardingAppSelection
          reposNodes={filteredRepoTreeData}
          reposFound={reposFound || 0}
          chooseAllSelected={isChooseAllSelected}
          onSelectChooseAll={onChooseAll}
          handleSearchRepos={handleSearchRepos}
          onContinueClick={onContinueClick}
          searchValue={searchValue}
          isLoading={isLoading}
          disableContinue={isContinueDisabled}
          handleMonitorNewResources={handleMonitorNewlyCreatedRepos}
          monitorNewResources={monitorAllNewlyCreatedResources}
          checkedReposNumber={checkedReposNumber}
          reposAmountAllowed={maxReposToScan}
        />
      )}
    </>
  );
};

export default OnboardingAppSelectionContainer;
